import React from 'react';
import {
    HeaderContainer,
    FooterContainer,
    BatchLabel,
    ParkedLabel,
    TitleLabel,
    FooterLabel,
    RedCircle,
    MultipleAllocations,
    RedCircleFlex,
    StyledDiv,
} from './BatchLocationCard.styled';
import { getDisplayDate } from 'src/utils/dateUtils';
import { convertTime24To12 } from 'src/utils/util';
import { useTranslation } from 'react-i18next';
import { getBrowserTimeZoneName } from 'src/utils/dateUtils';
import { useSelector } from 'react-redux';

export default function BatchLocationCard({
    option,
    isReservationSet = false,
}) {
    const { t } = useTranslation();
    return (
        <>
            {isReservationSet && option.id === 'Batch Not Found' ? (
                <div
                    style={{
                     //   height: '24px',
                    }}
                >
                    <TitleLabel fontFamily={'AvenirNextWorld Demi'}>
                        {option.currentLocation}
                    </TitleLabel>
                </div>
            ) : (
                <>
                    <HeaderContainer>
                        <BatchLabel>
                        {option.id 
                            ? `${t('scheduleSurgery.Shipping.BatchLocationCard.batchLabel')} ${option.id}` 
                            : 'Remove Selection'}
                        </BatchLabel>
                        {option.id && option.isParked && !isReservationSet ? (
                            <ParkedLabel>
                                {t(
                                    'scheduleSurgery.Shipping.BatchLocationCard.parkedLabel'
                                )}
                            </ParkedLabel>
                        ) : null}
                    </HeaderContainer>
                   {option?.id && <div
                        style={{
                           // height: '24px',
                        }}
                    >
                        <TitleLabel>{option.currentLocation}</TitleLabel>
                    </div>}
                </>
            )}
            {option.isBatchAlreadyAllocated && (
                <FooterContainer style={{ display: 'block' }}>
                    <RedCircleFlex>
                        <RedCircle style={{ marginTop: '3.5px' }}>!</RedCircle>
                        <FooterLabel color="#ED002A">
                            {t('equity.shipping.batchLocationCard.allocated')}
                        </FooterLabel>
                    </RedCircleFlex>
                    <StyledDiv>
                        {option.batchAlreadyAllocated?.map((data, index) => {
                            return (
                                <React.Fragment key={index}>
                                    <MultipleAllocations>
                                        <FooterLabel>
                                            {getDisplayDate(data.surgeryDate)}
                                        </FooterLabel>
                                        <FooterLabel>
                                            {convertTime24To12(
                                                new Date(data.surgeryDate)
                                            )}{' '}
                                            ({getBrowserTimeZoneName()})
                                        </FooterLabel>
                                        <FooterLabel>|</FooterLabel>

                                        <FooterLabel>
                                            {data.accountName}
                                        </FooterLabel>
                                    </MultipleAllocations>
                                </React.Fragment>
                            );
                        })}
                    </StyledDiv>
                </FooterContainer>
            )}
        </>
    );
}
